import { Dispatch, Action } from "redux";
import { loadAndTrack } from "redux-request-loading";
import { ThunkAction } from "redux-thunk";

import { SUBMIT_QUESTIONNAIRE, submitQuestionnaireSuccess, questionnaireLoaded } from "@teamprevent/common/questionnaires/actions";
import { AnsweredQuestionWithId } from "@teamprevent/common/questionnaires/model";
import { UPDATE_WORK_ADJUSTMENT_QUESTIONNAIRE_KEY, INITIAL_WORK_ADJUSTMENT_QUESTIONNAIRE_KEY } from "@teamprevent/common/workAdjustment/models";

import { workAdjustmentApi } from "./WorkAdjustmentApi";

export const loadInitialWorkAdjustmentQuestionnaire = (workAdjustmentCaseId: string, initialWorkAdjustmentDetailsTaskId: string) => {
    return async (dispatch: Dispatch) => {
        const response = await loadAndTrack(
            dispatch,
            "loadQuestionnaire",
            workAdjustmentApi.getInitialQuestionnaire(workAdjustmentCaseId, initialWorkAdjustmentDetailsTaskId)
        );
        const questions = response?.data?.questions ?? [];
        dispatch(questionnaireLoaded({ questions, questionnaireKey: INITIAL_WORK_ADJUSTMENT_QUESTIONNAIRE_KEY }));
    };
};

export const loadUpdateWorkAdjustmentQuestionnaire = (workAdjustmentCaseId: string, updateWorkAdjustmentTaskId: string) => {
    return async (dispatch: Dispatch) => {
        const response = await loadAndTrack(
            dispatch,
            "loadQuestionnaire",
            workAdjustmentApi.getUpdateQuestionnaire(workAdjustmentCaseId, updateWorkAdjustmentTaskId)
        );
        const questions = response?.data?.questions ?? [];
        dispatch(questionnaireLoaded({ questions, questionnaireKey: UPDATE_WORK_ADJUSTMENT_QUESTIONNAIRE_KEY }));
    };
};

export const updateWorkAdjustmentQuestionnaire = (workAdjustmentCaseId: string, updateWorkAdjustmentTaskId: string, questions: AnsweredQuestionWithId[]):
    ThunkAction<any, any, undefined, Action> => {
    return async (dispatch: Dispatch) => {
        const response = await loadAndTrack(
            dispatch,
            SUBMIT_QUESTIONNAIRE,
            workAdjustmentApi.updateWorkAdjustmentQuestionnaire(workAdjustmentCaseId, updateWorkAdjustmentTaskId, questions)
        );
        dispatch(submitQuestionnaireSuccess(UPDATE_WORK_ADJUSTMENT_QUESTIONNAIRE_KEY));
        return response.data;
    };
};
